import { ReactElement } from 'react';
import { CircularProgress, Typography } from '@mui/material';

import { useGetEvaluatedSettingsQuery } from '../../services/rtk/SettingsAPI';
import SettingsTable, { SettingsRowData } from './components/SettingsTable';

function MySettings(): ReactElement {
    const { data, isLoading, isError } = useGetEvaluatedSettingsQuery();

    if (isLoading) return <CircularProgress />;
    if (isError || !data) return <Typography color="error">Failed to load settings.</Typography>;

    const rows: SettingsRowData[] = Object.entries(data)
        .filter(([key]) => key !== 'metadata')
        .map(([key, value]) => ({
            key,
            setting: {
                description: data.metadata?.[key]?.description ?? key,
                value,
                overrides: null
            },
            metadata: data.metadata?.[key]
        }));

    return (
        <>
            <Typography variant="h5" gutterBottom>
                My Settings
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Your effective settings. Values marked "override" are customised for your account.
            </Typography>
            <SettingsTable rows={rows} />
        </>
    );
}

export default MySettings;
